import { PropsWithChildren } from "react";
import { Box, CircularProgress } from "@mui/material";

type Props = {
  loading: boolean;
};

export default function SpinnerWrapper({ loading, children }: PropsWithChildren<Props>) {
  return loading ? (
    <Box display="flex" flex="1" alignItems="center" justifyContent="center" width="100%" height="100%">
      <CircularProgress />
    </Box>
  ) : (
    <>{children}</>
  );
}
